<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getServiceTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionService && permissionService.permission_id === permission.readWrite"
          @click.native="createService" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable(header.id)">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.service_id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td align="center">
                <v-img :src="item.icon_show" style="width: 40px ;" />
              </td>
              <td>{{ item.title_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showServiceData(item.service_id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputSearch from "../../../components/Input/InputSearch";
import Loading from 'vue-loading-overlay';
// eslint-disable-next-line no-unused-vars
import moment from "moment";
import Paginate from "../../../components/Layout/Paginate";
import {permissionService, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Swal from 'sweetalert';

export default {
  name: "service",
  components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil, Loading },
  data() {
    return {
      title: "Service",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 11, text: "Branch" ,icon : true},
        { id: 3, text: "Icon" ,icon : null},
        { id: 4, text: "Service" ,icon : null},
        { id: 22, text: "Update date" ,icon : true},
        { id: 33, text: "Order" ,icon : null},
        { id: 7, text: "edit" ,icon : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort : 'asc',
      sort_date : 'desc',
      sort_branch : 'desc',
    };
  },
  computed: {
    permissionService,
  },
  created() {
    this.permission = role;
    this.getServiceTable(1);
  },
  methods: {
    goToServiceEdit() {
      this.$router.push("/service/edit");
    },
    getServiceTable(page) {
      this.isLoading = true;
      this.$store.dispatch("Services/getService",{
        page,
        search : this.search,
        sort_date : this.sort_date,
        sort_branch : this.sort_branch,
      }).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getServiceTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    createService() {
      this.$store.dispatch("Services/clearFormData").then(() => {
        this.goToServiceEdit();
      });
    },
    showServiceData(id) {
      this.isLoading = true;
      this.$store.dispatch("Services/showService", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Services/setFormService", res.result).then(() => {
            this.goToServiceEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(header_id){
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      if(header_id === 11){ //sort by branch
        this.sort_branch = this.sort_branch == 'desc' ? 'asc' : 'desc';
      }
      if(header_id === 22){ //sort by updated_at
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
      }
      this.getServiceTable(1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
